


























import {Component, Mixins} from 'vue-property-decorator';
import TranslatedRouter from '@/mixins/TranslatedRouter';

@Component({})
export default class Status extends Mixins(TranslatedRouter) {

	get listOfRoutes(): any {
		//@ts-ignore
		return this.$router.options.routes[0].children
	}

	mounted(): void {
	}

}
